import React from 'react'
import PropTypes from 'prop-types'
import { ErrorPageForCode } from '@maui/elements'

const error = {
  'No Content': {
    message: 'We can\'t seem to find the content you\'re looking for.'
  },
  403: {
    message: 'You are not authorized to view this page.'
  },
  404: {
    message: 'We can\'t seem to find the page you\'re looking for.'
  },
  407: {
    message: 'Sorry, you must be connected to the VPN to access this page.'
  },
  500: {
    message: 'Something went wrong. The server was unable to complete your request.'
  }
}

export function Error({ errorCode, customMessage }) {
  const message = customMessage || error[errorCode].message
  return <ErrorPageForCode code={errorCode} message={message} />
}

Error.propTypes = {
  customMessage: PropTypes.string,
  errorCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

Error.defaultProps = {
  customMessage: undefined,
  errorCode: 404
}
